// CyberNinja console easter egg voor Shopify
// Laden met: {{ 'cyberninja.js' | asset_url | script_tag }} met defer
(function () {
  var logo = [
    '',
    '   ______      __              _   ___       _',
    '  / ____/_  __/ /_  ___  ____ / | / (_)___  (_)___ _',
    ' / /   / / / / __ \\/ _ \\/ __//  |/ / / __ \\/ / __ `/',
    '/ /___/ /_/ / /_/ /  __/ /  / /|  / / / / / / /_/ /',
    '\\____/\\__, /_.___/\\___/_/  /_/ |_/_/_/ /_/_/\\__,_/',
    '     /____/',
    ''
  ].join('\n');

  console.log('%c' + logo, 'color:#00ff88;font-family:monospace;font-size:8px;line-height:8px;');
  console.log(
    '%cHandmade With Love By CyberNinja.be %chttps://cyberninja.be',
    'color:#00ff88;font-weight:bold;font-size:14px;',
    'color:#888;font-size:12px;'
  );
})();
